import type { ChannelAccount as ChannelAccountModel } from '@/adapters/catalogv1.g';

export function extractChannelAccount(model: ChannelAccountModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    channelRef: model.channel_ref ?? '',
    accountRef: model.account_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogChannelAccount = ReturnType<typeof extractChannelAccount>;
